// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Answer-Header-index-root-ysrXN","wrap":"src-components-Answer-Header-index-wrap-3-wEv","title":"src-components-Answer-Header-index-title-1-rA6","right":"src-components-Answer-Header-index-right-3PbAC","button":"src-components-Answer-Header-index-button-3tH7f","buttonActive":"src-components-Answer-Header-index-buttonActive-1FSl3 src-components-Answer-Header-index-button-3tH7f","correctBtn":"src-components-Answer-Header-index-correctBtn-2Nkkj","time":"src-components-Answer-Header-index-time-3ndUg"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Answer/Header/index.css
 ** module id = 255
 ** module chunks = 0
 **/